const urls = {
    TIMESHEET_DETAIL: 'jetty/vessel-timesheet-detail',
    TIMESHEET_HEADER: 'jetty/vessel-timesheet-header',
    TIMESHEET_MANDATORY: 'jetty/add-mandatory-details',
    TIMESHEET_HEADER_PRINT: 'jetty/vessel-timesheet-header-print',

    ULLAGE_HEADER: 'jetty/ullage-voyage-by-movement-instruction-header/',
    ULLAGE_DOCUMENTS: 'ullage-report-get-document-from-archiflow',
    ULLAGE: 'jetty/ullage-report'

}

import genericService from '../genericService';

export default {

    async getTimesheetDetail(body, callback){
        await genericService.get(urls.TIMESHEET_DETAIL, body).then(callback);
    },
    async getTimesheetHeader(body, callback){
        await genericService.getItem(urls.TIMESHEET_HEADER, body).then(callback);
    },
    async createTimesheetHeader(body, callback){
        await genericService.post(urls.TIMESHEET_HEADER, body).then(callback);
    },
    async createTimesheetDetail (body, callback){
        await genericService.post(urls.TIMESHEET_DETAIL, body).then(callback);
    },
    async createTimesheetMandatory (body, callback){
        await genericService.post(urls.TIMESHEET_MANDATORY, body).then(callback);
    },
    async printTimesheet(body, callback){
        await genericService.dowloadFile(urls.TIMESHEET_HEADER_PRINT, body).then(callback); 
    },
    async getUllage(id, callback){
        await genericService.getItem(urls.ULLAGE, id).then(callback);
    },
    async getUllageHeaders(id, callback){
        await genericService.getItem(urls.ULLAGE_HEADER, id).then(callback);
    },
    async getUllageDocuments(id, callback){
        await genericService.getItem(urls.ULLAGE_DOCUMENTS, id).then(callback);
    },
}